import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  border-left: 4px solid ${({ theme }) => theme.borders.workspaceSelectedItem};
  box-shadow: 0 0 20px 0 ${({ theme }) => theme.shadows.dashboard};
  background: ${({ theme }) => theme.backgrounds.dashboardItem};
  padding: 18px 24px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 8px;
`;

export const WorkspaceName = styled.h2`
  font-size: 22px;
  font-style: normal;
  line-height: 33px;
  font-weight: 600;
  margin: 0;
  color: ${({ theme }) => theme.text.dashboardTitle};
`;

export const ActiveBadge = styled.span`
  background-color: ${({ $active }) => ($active ? '#4dc5a8' : '#8da6be')};
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 17px;
  border: 1px solid #85c83e;
  background: rgba(133, 200, 62, 0.15);

  color: #85c83e;
  text-align: center;
  font-family: "Sequel Sans";
  font-size: 10px;
  font-style: normal;
  font-weight: 360;
  line-height: normal;
  letter-spacing: 0.3px;
  text-transform: uppercase;

  :before {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ $active }) => ($active ? '#85C83E' : '#8da6be')};
  }
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 24px;
`;

export const MetaItem = styled.div`
  display: flex;
  gap: 5px;
  font-size: 15px;
`;

export const MetaLabel = styled.span`
  color: ${({ theme }) => theme.text.dashboardDarkText};
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const MetaValue = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 12px;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.text.dashboardTitle};
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 365;
  line-height: normal;
`;

export const TitleRight = styled.h2`
  color: #63758d;
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: 0.8px;
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-family: "Sequel Sans";
  font-size: 15px;
  font-style: normal;
  font-weight: 355;
  line-height: 34px; /* 295.652% */
`;

export const SubtitleRight = styled.p`
  color: ${({ theme }) => theme.text.dashboardTitle};
  font-family: "Sequel Sans";
  font-size: 17.5px;
  font-style: normal;
  font-weight: 370;
  line-height: 33px;
`;

export const Dates = styled.p`
  color: ${({ theme }) => theme.text.dashboardDarkText};
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 360;
  line-height: normal;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const DateLabel = styled.p`
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  letter-spacing: 0.8px;
`;

export const MetricsContainer = styled.div`
  display: flex;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const MetricCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 28px;
  min-width: 120px;

  &:not(:first-child) {
    border-left: 1px solid ${({ theme }) => theme.borders.dashboard};
  }
`;

export const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.text.dashboardTitle};
`;

export const MetricLabel = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.dashboardLightText};
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const MetricContext = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.text.dashboardDarkText};
  margin-top: 4px;
`;

export const TimelineSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid ${({ theme }) => theme.borders.dashboard};
`;

export const TimelineTitle = styled.h3`
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 365;
  line-height: normal;
`;

export const TimelinePhases = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const PhaseItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
  z-index: 1;
`;

const CHIP_COLORS = {
  'completed': { border: '#85C83E', bg: 'rgba(133, 200, 62, 0.15)', color: '#85C83E' },
  'in-progress': { border: '#0082ED', bg: 'rgba(0, 130, 237, 0.12)', color: '#0082ED' },
  'pending': { border: '#63758d', bg: 'rgba(99, 117, 141, 0.1)', color: '#63758d' }
};

const chipColor = (prop) => ({ $status }) => {
  const c = CHIP_COLORS[$status] || CHIP_COLORS.pending;
  return c[prop];
};

export const PhaseChip = styled.div`
  display: flex;
  padding: 5px 15px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 27px;
  white-space: nowrap;
  border: 1px solid ${chipColor('border')};
  background: ${chipColor('bg')};
`;

export const ChipText = styled.div`
  text-align: center;
  font-family: "Sequel Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 360;
  line-height: normal;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${chipColor('color')};
`;

export const ChipIcon = styled.span`
  font-size: 12px;
  line-height: 1;
  color: ${chipColor('color')};
`;

export const StatusLabel = styled.div`
  font-family: "Sequel Sans";
  font-size: 11px;
  font-weight: 360;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${chipColor('color')};
`;

export const TimelineConnector = styled.div`
  flex: 1;
  height: 1px;
  margin-top: 11px;
  background-color: ${({ $fromStatus }) =>
    $fromStatus === 'completed' ? '#85C83E' : '#63758d'};
`;
